import { render } from "./userModal.vue?vue&type=template&id=79f742b5&scoped=true"
import script from "./userModal.vue?vue&type=script&lang=js"
export * from "./userModal.vue?vue&type=script&lang=js"

import "./userModal.vue?vue&type=style&index=0&id=79f742b5&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f742b5"]])

export default __exports__